import {
    generalCategoriesFulfilledConstants,
    generalCategoriesRejectedConstants,
    generalCategoriesPendingConstants
} from '../actions';

const initialState = {
    data: [],
    error: '',
    loading: true
};

export default function (state = initialState, action) {
    switch (action.type) {
        case generalCategoriesPendingConstants.GENERAL_CATEGORIES_LOADED:
            return initialState;
        case generalCategoriesFulfilledConstants.GENERAL_CATEGORIES_LOADED:
            return {
                ...initialState,
                data: [].concat(action.payload).sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                }),
                loading: false
            };
        case generalCategoriesRejectedConstants.GENERAL_CATEGORIES_LOADED:
            return {
                ...state,
                error: `${action.payload.response.data.errorMessage || action.payload.response.status + ' ' + action.payload.response.statusText}`,
                loading: false
            };
        case generalCategoriesFulfilledConstants.GENERAL_CATEGORY_CREATED:
            return {
                ...initialState,
                loading: false,
                data: [...state.data, action.payload]
            };
        case generalCategoriesFulfilledConstants.GENERAL_CATEGORY_UPDATED:
            return {
                ...state,
                loading: false,
                data: state.data.map(c => (c.id === action.payload.id ? action.payload : c))
            };
        case generalCategoriesFulfilledConstants.GENERAL_CATEGORY_DELETED:
            return {
                ...state,
                data: state.data.filter(c => c.id !== action.payload)
            };
        case generalCategoriesPendingConstants.GENERAL_CATEGORY_CREATED:
        case generalCategoriesPendingConstants.GENERAL_CATEGORY_UPDATED:
            return {
                ...state,
                loading: true
            };
        case generalCategoriesRejectedConstants.GENERAL_CATEGORY_CREATED:
        case generalCategoriesRejectedConstants.GENERAL_CATEGORY_UPDATED:
        case generalCategoriesRejectedConstants.GENERAL_CATEGORY_DELETED:
            return {
                ...state,
                loading: false,
                error: `${action.payload.response.data.errorMessage || action.payload.response.status + ' ' + action.payload.response.statusText}`,
                ...action.payload.response.data
            };
        default:
            return state;
    }
}
